import { createSlice, PayloadAction } from "@reduxjs/toolkit";


interface InitialState {
    data: "",
    error: string,
    loading: boolean
}
const initialState: InitialState =
{
    data: "",
    error: '',
    loading: false
}

const todoListSlice = createSlice({
    name: "todoListCount",
    initialState,
    reducers: {
        updateTodoListCount(state, action: PayloadAction<any>) {
            state.data = action.payload;
        },
    },
});

export const { updateTodoListCount } = todoListSlice.actions;

export default todoListSlice.reducer;